"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var WEEKDAYS_LONG = {
  en_US: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  fr_FR: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
  it_IT: ['Domenica', 'Lunedì', 'Martedì', 'Miercoledi', 'Giovedi', 'Venerdì', 'Sabato']
};
var WEEKDAYS_SHORT = {
  en_US: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  fr_FR: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
  it_IT: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa']
};
var MONTHS = {
  en_US: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  fr_FR: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
  it_IT: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre']
};
var FIRST_DAY = {
  en_US: 0,
  fr_FR: 1,
  // Use Monday as first day of the week
  it_IT: 1 // Use Monday as first day of the week
};

/**
 * Format Date as day
 *
 * @param Date d
 * @param string locale
 *
 * @returns string
 */
function formatDay(d) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en_US';
  var loc = this.formatLocale(locale);
  return "".concat(WEEKDAYS_LONG[loc][d.getDay()], ", ").concat(d.getDate(), " ").concat(MONTHS[loc][d.getMonth()], " ").concat(d.getFullYear());
}

/**
 * Format Date as month title
 *
 * @param Date d
 * @param string locale
 *
 * @returns string
 */
function formatMonthTitle(d) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en_US';
  var loc = this.formatLocale(locale);
  return "".concat(MONTHS[loc][d.getMonth()], " ").concat(d.getFullYear());
}

/**
 * Get the short version of a week day
 *
 * @param int i
 * @param string locale
 *
 * @returns string
 */
function formatWeekdayShort(i) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en_US';
  var loc = this.formatLocale(locale);
  return WEEKDAYS_SHORT[loc][i];
}

/**
 * Get the long version of a week day
 *
 * @param int i
 * @param string locale
 *
 * @returns string
 */
function formatWeekdayLong(i) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en_US';
  var loc = this.formatLocale(locale);
  return WEEKDAYS_LONG[loc][i];
}

/**
 * Get first day of the week
 * @param string locale
 *
 * @returns integer
 */
function getFirstDayOfWeek() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en_US';
  var loc = this.formatLocale(locale);
  return FIRST_DAY[loc];
}

/**
 * Get List of Months
 *
 * @param string locale
 *
 * @returns array
 */
function getMonths() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en_US';
  var loc = this.formatLocale(locale);
  return MONTHS[loc];
}

/**
 * Format locale
 *
 * @param string locale
 *
 * @return string
 */
function formatLocale(locale) {
  var loc = locale.split('-');
  if (loc.length !== 2) {
    loc = locale.split('_');
    if (loc.length !== 2) {
      return false;
    }
  }
  loc[1] = loc[1].toUpperCase();
  return loc.join('_');
}
var HiLocaleUtils = {
  formatDay: formatDay,
  formatMonthTitle: formatMonthTitle,
  formatWeekdayShort: formatWeekdayShort,
  formatWeekdayLong: formatWeekdayLong,
  getFirstDayOfWeek: getFirstDayOfWeek,
  getMonths: getMonths,
  formatLocale: formatLocale
};
var _default = exports.default = HiLocaleUtils;